/**
 * Counts the number of active (truthy) filter predicates.
 *
 * Used by filter sheet containers to compute active filter count badges.
 * @module features/scouting/utils/countActiveFilters
 */

/**
 * Counts truthy predicates -- used for filter count badges.
 * @param predicates - Boolean conditions to count
 * @returns Number of truthy predicates
 */
function countActiveFilters(...predicates: readonly boolean[]): number {
  return predicates.filter(Boolean).length;
}

export default countActiveFilters;
